<template>
  <div class="pagination">
    <el-pagination
      v-model:current-page="currentPage"
      :hide-on-single-page="true"
      layout="prev, pager, next"
      :total="props.pageData.length"
      :page-size="pageSize"
      @current-change="pageChanged"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  pageData: {
    type: Object,
    required: true
  }, // 分页数据
  pageSize: {
    type: Number,
    default: 9
  } // 一页展示的条数
})

/* 
  page_changed: 切换分页
*/
const emits = defineEmits(['page_changed'])

let currentPage = ref(1) // 当前选中的页数

const pageChanged = value => {
  currentPage.value = value
  emits('page_changed', value)
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_make.scss';
@import '@/assets/scss/common.scss';

.pagination {
  :deep(.el-pagination) {
    justify-content: center;
    line-height: 1.5;
    @include responsive-style(
      (
        font-size: 12px
      )
    );

    button {
      color: #19191a;
      box-sizing: content-box;
      @include responsive-style(
        (
          min-width: 16px,
          width: 16px,
          height: 16px,
          padding: 6px 10px,
          font-size: 12px
        )
      );

      &:disabled {
        color: #c2c4ce;
      }
    }

    li {
      min-width: 0;
      color: #828282;
      box-sizing: content-box;
      @include responsive-style(
        (
          height: 18px,
          padding: 6px 10px,
          font-size: 12px,
          line-height: 1.5
        )
      );

      &.is-active {
        color: #1f78e3;
      }
    }
  }
}
</style>
